import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from './projectsSlice';
import documentsReducer from './documentsSlice';
import requestsReducer from './requestsSlice';
import generateReducer from './generateSlice';

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    documents: documentsReducer,
    requests: requestsReducer,
    generate: generateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export default store;
